var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// eslint-disable-next-line import/no-extraneous-dependencies
import { createContext } from 'react';
export function groupItems(data) {
    return data
        .sort(function (a, b) {
        var first = a.group || '';
        var second = b.group || '';
        if (!first)
            return 1;
        if (!second)
            return -1;
        return first.localeCompare(second);
    })
        .reduce(function (prev, curr) {
        var _a;
        var group = curr.group || 'Ungrouped';
        return __assign(__assign({}, prev), (_a = {}, _a[group] = prev[group] ? __spreadArray(__spreadArray([], prev[group], true), [curr], false) : [curr], _a));
    }, {});
}
export function isSelected(value, current) {
    return Array.isArray(value)
        ? value.some(function (x) { return x.value === (current === null || current === void 0 ? void 0 : current.value); })
        : (value === null || value === void 0 ? void 0 : value.value) === (current === null || current === void 0 ? void 0 : current.value);
}
export function resolveSelected(value, selected, removeSelected, useMultipleSelect) {
    if (useMultipleSelect === void 0) { useMultipleSelect = false; }
    var isSelectedArray = Array.isArray(selected);
    var isValueArray = Array.isArray(value);
    if (!useMultipleSelect) {
        return selected;
    }
    if (isValueArray) {
        // eslint-disable-next-line no-nested-ternary
        var returnValue = removeSelected
            ? isSelectedArray
                ? value.filter(function (x) { return !selected.some(function (y) { return y.value === x.value; }); })
                : value.filter(function (x) { return x.value !== selected.value; })
            : __spreadArray(__spreadArray([], value, true), (isSelectedArray ? selected : [selected]), true);
        return returnValue.length ? returnValue : null;
    }
    return removeSelected ? null : __spreadArray([], (isSelectedArray ? selected : [selected]), true);
}
export function resolveLabel(value, areAllSelected) {
    if (areAllSelected === void 0) { areAllSelected = false; }
    if (Array.isArray(value)) {
        return !value.length ? null : "".concat(areAllSelected ? 'All' : value.length, " selected");
    }
    return value && value.label;
}
export var scrub = function (value) {
    return value != null ? value.replaceAll(' ', '-').toLowerCase() : value;
};
export function createComboboxContext() {
    return createContext({
        onChange: function () { },
        value: null,
        isOpen: false,
        openMenu: function () { },
        closeMenu: function () { },
        selectAll: function () { },
        onAdd: function () { },
        areAllSelected: false,
        useGrouping: undefined,
        useMultipleSelect: undefined,
        usePillList: undefined,
        useAutocomplete: undefined,
        testSelector: '',
        addItemLabel: undefined,
        handleSelect: undefined,
    });
}
export function getSelectedItemByValue(value, items) {
    var _a, _b;
    if (Array.isArray(value)) {
        return (_a = items.filter(function (x) { return value.some(function (y) { return y === x.value; }); })) !== null && _a !== void 0 ? _a : null;
    }
    return (_b = items.find(function (x) { return x.value === value; })) !== null && _b !== void 0 ? _b : null;
}
